import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Получить главный виджет с графиками
export const getMacroWidget = async () => {
  const url = `${backendUrl}/api/widgets/macro-widget/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Ошибка при получении главного виджета: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка получения главного виджета:', error);
    throw error;
  }
};